import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';
import { useCallback, useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { capitalizeFirstLetter, getOrgIdAndPropertyIdFromURL } from 'utils';
import { API_URL } from 'utils/constants';

const prepareBody = (formData) => {
  const body = { ...formData };

  Object.keys(body).forEach((name) => {
    const field = body[name];
    if (!field?.length && !field?.toString()) {
      delete body[name];
    }
    if (name === 'moveInDateFrom' && field?.toString()) {
      body.moveInDateFrom = formatDateDB(formData.moveInDateFrom);
    }
  });

  return body;
};
export const useContactUs = () => {
  const { propertyId, organizationId } = getOrgIdAndPropertyIdFromURL();

  const [isSuccessful, setIsSuccessful] = useState(false);

  const {
    handleSubmit,
    control,
    getValues,
    getFieldState,
    reset,
    formState: { errors, isValid, isDirty, isSubmitSuccessful, isSubmitting },
    setError,
    clearErrors,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      nBeds: '',
      nBaths: '',
      moveInDateFrom: '',
      emails: [{ value: '', isPrimary: true, type: 'Personal' }],
      phones: [{ value: '', isPrimary: true, type: 'Mobile' }],
    },
    mode: 'onBlur',
  });

  const { mutateAsync } = useMutation(async (formData) => {
    const body = JSON.stringify(prepareBody(formData));
    const response = await fetch(
      `${API_URL}/${organizationId}/${propertyId}/contactUs`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      },
    );

    if (!response.ok) {
      const json = await response.json();
      const { validation, message, statusCode } = json;

      if (validation?.keys?.length && statusCode === 400) {
        validation.keys.forEach((key) =>
          setError(key, {
            type: 'error',
            message: capitalizeFirstLetter(message.replace(`"${key}" `, '')),
          }),
        );
      }
    } else {
      setIsSuccessful(true);

      if (ReactGA.isInitialized) {
        ReactGA.event('form_submit', {
          category: 'Form',
          label: 'Contact Us',
        });
      }
    }
  });

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset();
      setTimeout(() => {
        setIsSuccessful(false);
      }, 2000);
    }
  }, [reset, isSubmitSuccessful]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onSubmit = useCallback(handleSubmit(mutateAsync), [
    handleSubmit,
    mutateAsync,
  ]);

  const ReactHookFormProps = {
    Controller,
    control,
    getValues,
    setError,
    setValue,
    clearErrors,
    errors,
    getFieldState,
    isValid,
    isDirty,
    watch,
  };

  return {
    onSubmit,
    isSuccessful,
    isSubmitting,
    submitDisabled: isSubmitSuccessful || isSubmitting,
    ReactHookFormProps,
  };
};
